import { SET_PHOTO_DATA, MODAL_SHOW, MODAL_TYPE_SUCCESS } from "../constants/constants"

export const photoData = (data: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_PHOTO_DATA, payload: data
        })
    }
}

export const confirmSubmission = () => {
    return (dispatch) => {
        dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_SUCCESS,
                isHtml: true,
                header: "<div class='text-center'><Image src='/Images/ChilliDetails/MileageMonthly/icons-checkmark-default-checked-32-px.svg' /></div>",
                body: "<div class='text-center'><h3>Submitted successfully</h3><p>We'll let you know if we need more info</p></div>",
            }
        })
    };
}